import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import A5Screening from "@/components/Screening/A5Screening";
import AccountSetup from "@/components/Common/Workflow/AccountSetup";
import AdvancedCarePolicyPage from "@/containers/PublicPages/AdvancedCarePolicyPage";
import Authentication from "@/containers/Authentication/Authentication";
import EmailVerification from "@/components/Common/EmailVerification";
import HCPWorkflow from "@/components/Common/Workflow/HCPWorkflow/HCPWorkflow";
import HipaaPolicyPage from "@/containers/PublicPages/HipaaPolicyPage";
import Home from "@/containers/Home/Home";
import MobileAddPayment from "@/components/Common/MobileAddPayment/MobileAddPayment";
import PricingPage from "@/containers/PublicPages/PricingPage";
import privacyPolicy from "@/components/Common/PrivacyPolicy";
import PrivacyPolicyPage from "@/containers/PublicPages/PrivacyPolicyPage";
import RedirectSplashScreen from "@/redirectSplashScreen";
import TermsAndConditionsPolicyPage from "@/containers/PublicPages/TermsAndConditionsPolicyPage";
import TreatmentPolicyPage from "@/containers/PublicPages/TreatmentPolicyPage";
import Unsubscribe from "@/components/Common/Unsubscribe";
import Workflow from "@/components/Common/Workflow";

export const getUnauthenticatedRoutes = (allowRedirect, props) => (
  <Switch>
    <Route component={Home} exact path="/" />
    <Route component={AccountSetup} path="/account-setup" />
    <Route component={Authentication} path="/auth" />
    <Route component={privacyPolicy} path="/privacy-policy" />
    <Route component={PricingPage} path="/session-pricing" />
    <Route component={A5Screening} path="/a5-screening" />
    <Route component={Unsubscribe} path="/unsubscribe" />
    <Route component={EmailVerification} path="/email-verification" />
    <Route component={Workflow} path="/app/workflow" />
    <Route component={MobileAddPayment} path="/app/mobile-add-payment" />

    <Route component={AdvancedCarePolicyPage} path="/advanced-care" />
    <Route component={TreatmentPolicyPage} path="/consent" />
    <Route component={HipaaPolicyPage} path="/hipaaprivacy" />
    <Route component={PrivacyPolicyPage} path="/privacy" />
    <Route component={TermsAndConditionsPolicyPage} path="/terms-and-conditions" />

    <Route
      component={(compProps) => (
        <RedirectSplashScreen {...compProps} redirectPath={props.auth.authRedirectPath} />
      )}
      path="/redirect"
    />

    <Route component={HCPWorkflow} path="/app/hcp-workflow" />

    {allowRedirect && <Redirect to="/auth" />}
  </Switch>
);
